import PaymentMethodsModal from './PaymentMethodsModal';
import AddCreditCard from './add-credit-card';

export default {
  PaymentMethodsModal,
  AddCreditCard,
};
